import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { SnipAnalysisListScreen } from "./SnipAnalysisListScreen";
import { SnipSessionsListScreen } from "./SnipSessionsListScreen";
import { SnipAnalysisScreen } from "./SnipAnalysisScreen";
import { PrivateRoute } from "../../../Core/PrivateRoute";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";

export const SnipRoot = () => {
    return (
        <Switch>
            <PrivateRoute path="/Snip" exact permissions={[PermissionEnum.AccessSingleSnipSession, PermissionEnum.AccessAllSnipSessions, PermissionEnum.OverreadSnipSession]}>
                <SnipSessionsListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Snip/Analysis" exact permissions={[PermissionEnum.OverreadSnipSession]}>
                <SnipAnalysisListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Snip/Analysis/:analysisSetId/:viewState" permissions={[PermissionEnum.OverreadSnipSession, PermissionEnum.AccessSingleSnipSession]}>
                <SnipAnalysisScreen />
            </PrivateRoute>
        </Switch>
    );
}
